import { AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';

export function isErrorState(
  control: AbstractControl | null,
  form: FormGroupDirective | NgForm | null
): boolean {
  return !!(control && control.invalid && form && form.submitted);
}
